import { observer } from 'mobx-react'
import React from 'react'
import AddToBalance from './AddToBalance'
import StakingFormVM from './StakingFormVM'
import UserBalances from './UserBalances'

export function StakingForm({ vm }: { vm: StakingFormVM }) {
  const { userBalances } = vm.stakingStore
  const { wallet, staked } = userBalances

  return (
    <>
      <UserBalances rootStore={vm.rootStore} />
      {(wallet.isWorthEnough || staked.isWorthEnough) && <AddToBalance vm={vm} />}
    </>
  )
}

export default observer(StakingForm)
